module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/how_to_enjoy_photography_case4-0dd05ab6408654b6eef4582bad541385.jpg";